import { Component, Output, EventEmitter, Renderer2, OnInit, OnDestroy, inject } from '@angular/core';
import { WordCloudService } from '@services/word-cloud/word-cloud.service';

@Component({
  selector: 'app-word-cloud-error-modal',
  templateUrl: './word-cloud-error-modal.component.html',
  styleUrls: ['./word-cloud-error-modal.component.scss'],
  standalone: false,
})
export class WordCloudErrorModalComponent implements OnInit, OnDestroy {
  private renderer = inject(Renderer2);
  private wordCloudService = inject(WordCloudService);

  @Output() closeFilter = new EventEmitter<any>();
  title: String;
  errorMessage: String;

  ngOnInit() {
    this.getTitle();
    this.getErrorMessage();
    this.renderer.addClass(document.body, 'modal-open');
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'modal-open');
  }

  getTitle(): void {
    this.title = this.wordCloudService.modalTitle;
  }

  getErrorMessage(): void {
    this.errorMessage = this.wordCloudService.modalErrorMessage;
  }

  onClose() {
    this.closeFilter.emit();
  }
}
